export default __webpack_public_path__ + "static/media/js.e0679884.svg";